<template>
    <div>
        <div class="form-group" v-if="journal_templates.length > 0">
            <label class="control-label">{{ trans('client.journal_template') }}</label>
            <select v-model="selected_template" class="form-control" name="journal_templates">
                <option :value="0">{{ trans('client.journal_template') }}</option>
                <option v-for="journal_template in journal_templates" :value="journal_template.id" :key="journal_template.id">{{ journal_template.title }}</option>
            </select>
            <small class="text-muted" v-if="journal_templates.length > 1">{{ trans('client.templates_helper_text') }}</small>
        </div>
        <div class="tip" v-if="journal_templates.length === 0 && journal_templates_loaded">
            <small class="hidden-xs">{{ trans('client.journal_template_tip_1') }}<span v-sanitize-html="trans('client.journal_template_tip_2')"></span></small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JournalTemplateSelect',

    emits: ['templateSelected', 'templateIdSelected'],

    data() {
        return {
            selected_template: 0,
        };
    },

    mounted() {
        this.$store.dispatch('journals/loadTemplates');

        this.$event_bus.$on('resetJournalTemplateSelection', this.resetSelectedTemplate);
    },

    beforeUnmount() {
        this.$event_bus.$off('resetJournalTemplateSelection', this.resetSelectedTemplate);
    },

    methods: {
        resetSelectedTemplate() {
            this.$nextTick(() => {
                this.selected_template = 0;
            });
        },

        selectJournalTemplate(templateId) {
            const template = this.$store.getters['journals/getTemplateById'](templateId);

            if (template) {
                this.$emit('templateSelected', template);
                this.$emit('templateIdSelected', template.id);
            }
        },
    },

    computed: {
        journal_templates() {
            return this.$store.getters['journals/templates'].slice(0).sort((a, b) => {
                if (a.order > b.order) {
                    return 1;
                }

                if (a.order < b.order) {
                    return -1;
                }

                if (a.order == b.order) {
                    return a.title.localeCompare(b.title, locale);
                }
            });
        },

        journal_templates_loaded() {
            return this.$store.state.journals.templatesLoaded;
        },
    },

    watch: {
        selected_template: {
            handler: function(val, oldVal) {
                this.selectJournalTemplate(val)
            }
        },
    }
}
</script>
